module.exports = __webpack_public_path__ + "img/img-parts-sishu03-2.02e96e98.png";